// src/services/api.service.ts
import { Request } from '../helpers/Request';

import {
  ServiceCategoryResponseDTO, ServiceResponseDTO,
  BookingCreateDTO, BookingResponseDTO, DeleteBookingDTO,
  PersonRangeResponseDTO,
  SlotTypeCreateDTO,
  AvailableSlotDTO} from '../components/types/ZaprosDTO';

const cache = new Map<string, { data: any; timestamp: number }>();
const CACHE_DURATION = 5 * 60 * 1000;

export class ApiService {
  // ==============================================
  // Категории услуг
  // ==============================================
  static async getCategories(): Promise<ServiceCategoryResponseDTO[]> {
    // const cacheKey = `categories_${initData}`;
    // const cached = cache.get(cacheKey);
    
    // if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    //   return cached.data;
    // }

    try {
      const { responseData } = await Request<ServiceCategoryResponseDTO[]>({
        method: 'GET',
        url: `/service-categories/getServiceCategories`,
       // headers: initData ? { "X-Telegram-Init-Data": initData } : {}
      });
      console.log('Полученные категории:', responseData);
      // Проверяем наличие данных и фильтруем их
      const validData = (responseData || []).filter(cat => 
        cat.id > 0 && 
        cat.name?.trim() && 
        cat.photo?.trim()
      );

      if (validData.length === 0) {
        throw new Error('Нет доступных категорий');
      }

      // cache.set(cacheKey, { data: validData, timestamp: Date.now() });
      return validData;
    } catch (error) {
      console.error('Ошибка загрузки категорий:', error);
      throw error;
    }
  }

  // ==============================================
  // Диапазоны персон
  // ==============================================
  static async getPersonRanges(category_id: number): Promise<PersonRangeResponseDTO[]> {
    try {
      const { responseData } = await Request<PersonRangeResponseDTO[]>({
        method: 'GET',
        url: `/person-ranges/${category_id}`, 
      });
      return responseData || [];
    } catch (error) {
      console.error('Ошибка загрузки диапазонов:', error);
      throw error;
    }
  }

  //==============================================
  //    Новые Услуги
  //==============================================
  static async getServicesByCategory(categoryId: number): Promise<ServiceResponseDTO[]> {
    try {
      const { responseData } = await Request<ServiceResponseDTO[]>({
        method: 'GET',
        url: `/services/getServiceByCategory/${categoryId}`,
      });
      
      return responseData?.filter(s => 
        s.service_id > 0 && 
        s.price_per_unit > 0
      ) || [];
      
    } catch (error) {
      console.error('Ошибка загрузки услуг:', error);
      throw error;
    }
  }

  // ==============================================
  // Услуги
  // ==============================================
static async getServices(
  service_id: number,
): Promise<ServiceResponseDTO[]> {
  if (service_id > 118) throw new Error('Некорректный ID категории');

  const cacheKey = `services_${service_id}`;
  const cached = cache.get(cacheKey);

  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }

  try {
    const { responseData } = await Request<ServiceResponseDTO[] | ServiceResponseDTO>({
      method: 'GET',
      url: `/services/${service_id}`,
    });

    //  Обрабатываем одиночный объект как массив
    const normalizedData = Array.isArray(responseData) 
      ? responseData 
      : responseData ? [responseData] : [];

    console.log('Нормализованные данные услуг:', normalizedData);
    
    if (normalizedData) cache.set(cacheKey, { data: normalizedData, timestamp: Date.now() });
    return normalizedData || [];
  } catch (error) {
    console.error(`Ошибка загрузки услуг для категории ${service_id}:`, error);
    throw error;
  }
}
  // ==============================================
  // Бронирования
  // ==============================================
  static async createBooking(bookingData: BookingCreateDTO): Promise<void> {
    try {
      // Убираем лишние поля и преобразуем типы
      const payload = {
        service_id: Number(bookingData.service_id),
        object_id: 0,
        booking_date: `${bookingData.booking_date}T${bookingData.start_time}`,
        start_time: `${bookingData.booking_date}T${bookingData.start_time}`,
        end_time: `${bookingData.booking_date}T${bookingData.end_time}`,
        quantity: Number(bookingData.quantity),
        total_price: bookingData.total_price,
        added_to_cart_time: bookingData.added_to_cart_time
      };
  
      console.log('Final payload:', payload);
      
      await Request({
        method: 'POST',
        url: `/bookings`,
        data: payload,
        headers: {
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error('Ошибка создания бронирования:', error);
      throw error;
    }
  }

    /**
   * Получение списка бронирований пользователя
   * @param initData Данные инициализации Telegram
   */
    static async getBookings(initData?: string): Promise<BookingResponseDTO[]> {
      try {
        const { responseData } = await Request<BookingResponseDTO[]>({
          method: 'GET',
          url: `/bookings`,
          headers: initData ? { "X-Telegram-Init-Data": initData } : {}
        });
        return responseData || [];
      } catch (error) {
        console.error('Ошибка загрузки бронирований:', error);
        throw error;
      }
    }
    /**
   * Удаление бронирования
   * @param bookingId ID бронирования
   */
    static async deleteBooking(bookingId: number, initData?: string): Promise<DeleteBookingDTO> {
      try {
        const { responseData } = await Request<DeleteBookingDTO>({
          method: 'GET', // Меняем метод на GET
          url: `/bookings/delete/${bookingId}`,
          headers: initData ? { 
            //"X-Telegram-Init-Data": initData,
            "Content-Type": "application/json"
          } : {}
        });
        
        return responseData || { message: "Бронирование удалено", booking_id: bookingId };
      } catch (error) {
        console.error('Ошибка удаления бронирования:', error);
        throw error;
      }
    }

      // ==============================================
  // Создание типа слота
  // ==============================================
  static async createSlotType(slotData: SlotTypeCreateDTO): Promise<void> {
    try {
      await Request({
        method: 'POST',
        url: `/slot-types/`,
        data: slotData,
        headers: {
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error('Ошибка создания слота:', error);
      throw error;
    }
  }

    // ==============================================
  // Доступные слоты
  // ==============================================
  static async getAvailableSlots(
    serviceId: number,
    bookingDate: string
  ): Promise<AvailableSlotDTO[]> {
    try {
      console.log('[API][SLOTS] Запрос слотов:', { serviceId, bookingDate });
      const { responseData } = await Request<AvailableSlotDTO[]>({
        method: 'GET',
        url: `/slot-types/available-slots?service_id=${serviceId}&booking_date=${bookingDate}`,
      });
  
      const safeResponseData = responseData || [];
      
      // Для тестирования можно раскомментировать:
      // const testResponse = safeResponseData.map(slot => ({
      //   ...slot,
      //   is_available: false
      // }));
      
      console.log('[API][SLOTS] Ответ:', safeResponseData);
      return safeResponseData;
    } catch (error) {
      console.error('[API][SLOTS] Ошибка:', error);
      throw error;
    }
  }

  // ==============================================
// Настройки
// ==============================================
static async getPayUrl(): Promise<string> {
  try {
    const { responseData } = await Request<string>({
      method: 'GET',
      url: `/settings/pay_url`,
      headers: {
        "Accept": "application/json"
      }
    });
    return responseData || '';
  } catch (error) {
    console.error('Ошибка получения URL:', error);
    return '';
  }
}

static async getAdminUrl(): Promise<string> {
  try {
    const { responseData } = await Request<string>({
      method: 'GET',
      url: `/settings/admin_url`,
      headers: {
        "Accept": "application/json"
      }
    });


    return responseData || '';
  } catch (error) {
    console.error('Ошибка получения URL:', error);
    return '';
  }
}

}

